import { ShareIcon } from "@/components/Icon";
import { CircleButton } from "_c/Button";
import { useState } from "react";
import type { TShareProps } from "./typings";
import { useShareProviders } from "./hooks";
import ShareProviderButton from "./ShareProviderButton";
import cls from "./styles.module.css";
import { AnimatePresence, motion } from "framer-motion";
import { ClientOnly } from "@tanstack/react-router";

export default function PostShare(props: TShareProps) {
  const [opened, setOpened] = useState(false);
  const providers = useShareProviders(props);
  const title = "Поделиться";
  const isNativeShareSupported = Boolean(navigator.share);
  const shareOptionsRootId = "share-options-dropdown";
  return (
    <div className={cls.root}>
      <CircleButton
        title={title}
        aria-label={title}
        aria-controls={isNativeShareSupported ? undefined : shareOptionsRootId}
        aria-expanded={isNativeShareSupported ? undefined : opened}
        onClick={() => {
          if (isNativeShareSupported) {
            navigator.share({ url: props.link });
          } else {
            setOpened(!opened);
          }
        }}
        className={cls.btn}
      >
        <ShareIcon size={32} aria-hidden />
      </CircleButton>
      <ClientOnly>
        <AnimatePresence>
          {opened && (
            <motion.div
              className={cls.providersRoot}
              exit="hidden"
              animate="visible"
              initial="hidden"
              id={shareOptionsRootId}
              transition={{
                staggerChildren: 0.02,
              }}
            >
              {providers.map((provider, idx) => (
                <ShareProviderButton
                  isActive={opened}
                  idx={idx}
                  length={providers.length}
                  key={idx}
                >
                  {provider}
                </ShareProviderButton>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </ClientOnly>
    </div>
  );
}
